import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import {
  Header,
  Aside,
  Client,
  ClientAdd,
  Users,
  UserView,
  UserAdd,
  Handbooks,
  ExchangeKB,
  Overdue,
  QuickCalculation,
  SearchResults,
  ReportsMain,
  ReportsNBRB,
  Notifications,
  AutoLombardLayout,
  RequestDetails
} from './components';
import { getConfiguration, getCurrentUser } from './redux/actions/userAction';
import { permissionsAccess } from "./helpers/common";
import ReportsGrossProceeds from "./components/Reports/ReportsGrossProceeds/ReportsGrossProceeds";

const Page = ({ message }) => {
  const { userInfo } = useSelector(({ user }) => user);
  const [isMainMenuShown, setIsMainMenuShown] = useState(false);
  const dispatch = useDispatch();
  const [titlePage, setTitlePage] = useState('')

  useEffect(() => {
    dispatch(getCurrentUser());
    dispatch(getConfiguration());
  }, [dispatch]);

  const toggleMenuShownHandler = useCallback(() => {
    document.body.classList.toggle('aside-open');
    setIsMainMenuShown(!isMainMenuShown);
  }, [isMainMenuShown]);
  let accessKB = permissionsAccess("action.integration.kb.list")
  let accessNotifications = permissionsAccess("action.sms.list")

  return (
    <>
      <Header onChangeMenuState={toggleMenuShownHandler} user={userInfo} message={message} titlePage={titlePage} />
      <Aside isMainMenuShown={isMainMenuShown} onChangeMenuState={toggleMenuShownHandler} />
      <Route path="/cash-desk/cash" exact render={(props) => <ReportsMain setTitlePage={setTitlePage} />} />
      <Route path="/cash-desk/reports" exact render={(props) => <ReportsMain setTitlePage={setTitlePage} />} />
      <Route path="/client" exact render={(props) => <ClientAdd setTitlePage={setTitlePage} />} />
      <Route path="/client/:id" render={(props) => <Client setTitlePage={setTitlePage} />} />
      <Route path="/users" exact render={(props) => <Users setTitlePage={setTitlePage} />} />
      <Route path="/user/:id" exact render={(props) => <UserView setTitlePage={setTitlePage} />} />
      <Route path="/user" exact render={(props) => <UserAdd setTitlePage={setTitlePage} />} />
      <Route path="/handbooks/:handbook" render={(props) => <Handbooks setTitlePage={setTitlePage} />} />
      <Route path="/exchange-kb" exact render={(props) => accessKB ? <ExchangeKB setTitlePage={setTitlePage} /> : null} />
      <Route path="/notification" exact render={(props) => accessNotifications ? <Notifications setTitlePage={setTitlePage} /> : null} />
      <Route path="/auto" render={() => <AutoLombardLayout setTitlePage={setTitlePage} />} />
      <Route path="/overdue" exact render={(props) => <Overdue setTitlePage={setTitlePage} />} />
      <Route path="/quick-calculation" exact render={(props) => <QuickCalculation setTitlePage={setTitlePage} />} />
      <Route path="/search-results/:searchTab" exact render={(props) => <SearchResults setTitlePage={setTitlePage} />} />
      <Route
        path="/cash-desk/reports-nbrb"
        exact
        render={(props) => {
          if (!permissionsAccess('report.generate.nbrb')) {
            return <Redirect to="/cash-desk/reports" />;
          }
          return <ReportsNBRB />;
        }}
      />
        <Route
            path="/cash-desk/reports-grossproceeds"
            exact
            render={(props) => {
                if (!permissionsAccess('action.report.generate.gross_income')) {
                    return <Redirect to="/cash-desk/reports" />;
                }
                return <ReportsGrossProceeds />;
            }}
        />
    </>
  );
};

export default Page;
